module.exports = __webpack_public_path__ + "static/media/discord.145dc557.svg";